import React, { createContext, useContext, useEffect } from "react";

/* The site is 100% free and anonymous: no e-mail, no account, no subscription. */
const LEGACY_EMAIL_KEY = "astrovoyance.email";
const VALUE = { email: null, setEmail: () => {}, status: { premium_active: true }, refresh: () => {} };

const Ctx = createContext(VALUE);

export function AccountProvider({ children }) {
  useEffect(() => { localStorage.removeItem(LEGACY_EMAIL_KEY); }, []);
  return <Ctx.Provider value={VALUE}>{children}</Ctx.Provider>;
}

export const useAccount = () => useContext(Ctx);
